import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-isk-bg" data-testid="hero-section">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/hero-building.png"
          alt="Modern luxury apartment"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-isk-dark/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1
              className="text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6"
              data-testid="hero-title"
            >
              <span className="text-teal-300">Profit</span> meningkat.<br />
              Properti <span className="bg-gradient-to-r from-[#C9A77E] via-[#F0D5A0] to-[#C9A77E] bg-clip-text text-transparent">terawat.</span>
            </h1>

            <p
              className="text-lg md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed"
              data-testid="hero-subtitle"
            >
              Dari menjaga kualitas bangunan hingga memastikan kenyamanan penghuni, ISK membantu kost Anda <span className="font-semibold text-isk-gold">lebih terawat</span>, <span className="font-semibold text-isk-gold">lebih menguntungkan</span>, dan <span className="font-semibold text-isk-gold">lebih disukai tenant</span>.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-isk-teal hover:bg-isk-dark text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all"
                data-testid="hero-cta-primary"
              >
                Ajukan Kerja Sama
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>

              <Button
                onClick={() => scrollToSection('testimonials')}
                variant="outline"
                className="bg-white/10 hover:bg-white/20 text-white border-2 border-white/40 rounded-full px-8 py-6 text-lg font-semibold backdrop-blur-sm transition-all"
                data-testid="hero-cta-secondary"
              >
                Lihat Testimonies
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
